import { SaveOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Space, Tabs, Radio } from 'antd';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { Input, InputNumber } from 'antd/lib';
import NhanVienSelectBox from '../utils/NhanVienSelectBox';
import { layDangKyNgoaiGio, luuDangKyNgoaiGio, trinhDangKyNgoaiGio, duyetDangKyNgoaiGio, duaYKienDonNgoaiGio } from '../../services/ngoaigio';
import { DonNgoaiGio } from '../../models/ngoaigio/DonNgoaiGio';
import { layNguoiPheDuyet_YKienPhepMacDinh } from '../../services/donnghiphep';
import NhanVienPhongBanSelectBox from '../utils/NhanVienPhongBanSelectBox';
import BanGiamDocSelectBox from '../utils/BanGiamDocSelectBox';

const DangKyThemGio = () => {
    const { TextArea } = Input;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.NgoaiGio.DangKy, Links.NgoaiGio.PheDuyet]);
    const [form] = useForm();
    const [formConfirmModal] = useForm();
    const [donNgoaiGio, setDonNgoaiGio] = useState<DonNgoaiGio>( new DonNgoaiGio);
    const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
    const [trinhLanhDao, setTrinhLanhDao] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuyet, setOpenModalDuyet] = useState(false);
    const [noiDung, setNoiDung] = useState<string>("");
    const [reload, setReload] = useState(false);
    const [idNgoaiGio, setIdNgoaiGio] = useState(0);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");
    const [formDuaYKien] = useForm();
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [idNguoiYKien, setIdNguoiYKien] = useState(0);
    
    function onFinish(values: any) {
        setConfirmModal({
            isShowModal: true,
            title: trinhLanhDao ? "Lưu & Gửi phê duyệt đơn làm thêm giờ" : "Lưu đơn làm thêm giờ",
            content: trinhLanhDao ?
                <>Bạn có muốn <label>Lưu & Gửi phê duyệt</label> đơn đăng ký làm thêm giờ này không?</> :
                <>Bạn có muốn <label>Lưu</label> đơn đăng ký làm thêm giờ này không?</>,

                onSubmit: () => { eventSave(); }
        });
    }

    const onTrinh = () => {
        setTrinhLanhDao(true);
    }

    const eventSave = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = { ...values, trinhLanhDao: trinhLanhDao };
                const id = await luuDangKyNgoaiGio(request);
                toast.success(trinhLanhDao ? "Lưu và gửi phê duyệt đơn thêm giờ thành công" : "Lưu đơn thêm giờ thành công");
                navigate(Links.NgoaiGio.Xem + "?id=" + id);
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const trinhDangKy = async () => {
        dispatch(showLoadingScreen());
        try {
            var data = await trinhDangKyNgoaiGio(donNgoaiGio?.id || 0);
            form.setFieldsValue({ ...data, ngay: dayjs(data.ngay) });
            setDonNgoaiGio({ ...data });
            navigate(Links.NgoaiGio.Xem + "?id=" + data.id);
            toast.success("Đăng ký thêm giờ thành công");
        }
        catch (ex: any) {
            toast.error(ex);
        }

        dispatch(hideLoadingScreen());
    }


    const onDuaYKien = async () => {
        formDuaYKien.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                await duaYKienDonNgoaiGio({
                    id: donNgoaiGio.id,
                    isDuyet: values.duyet,
                    noiDung: values.noiDung || ""
                });
                toast.success("Đưa ý kiến thành công.");
                setReload(true);
            } catch (ex: any) {
                toast.error(ex);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

            dispatch(hideLoadingScreen());
        })
    }


    const eventPheDuyet = async (duyet: boolean) => {
        try {
            if (idNgoaiGio == 0) {
                toast.error("có lỗi xảy ra");
            }
            await duyetDangKyNgoaiGio({
                id: idNgoaiGio,
                isDuyet: duyet,
                noiDung: noiDung,
            });
            toast.success("Phê duyệt đơn nghỉ phép thành công.");
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const getById = async (id: any) => {
        dispatch(showLoadingScreen());
        try {
            var data = await layDangKyNgoaiGio(id);
            form.setFieldsValue({ ...data, ngay: dayjs(data.ngay) });
            setDonNgoaiGio(data);
        }
        catch (ex: any) {
            toast.error(ex);
        }

        dispatch(hideLoadingScreen());
    }

    const layNguoiMacDinh = async () => {
        dispatch(showLoadingScreen());
        var rs = await layNguoiPheDuyet_YKienPhepMacDinh();
        form.setFieldsValue({
            id: 0,
            kinhGui: "",
            lyDo: "",
            diaDiemLamViec: "",
            idNguoiDuyet: rs.idNhanVienDuyet > 0 ? rs.idNhanVienDuyet : null,
            idNguoiYKien: rs.idNhanVienYKien > 0 ? rs.idNhanVienYKien : null
        });
        if (rs.idNhanVienYKien > 0) {
            setIdNguoiYKien(rs.idNhanVienYKien);
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        setIsReadOnly((donNgoaiGio?.trangThai || 0) > 0);
    }, [donNgoaiGio]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        if (id > 0) {
            setIdNgoaiGio(id)
            getById(id);
        }
        else {
            layNguoiMacDinh();
        }
    }, []);

    return (
        <section>
            <ContentHeader title="Đăng ký thêm giờ" />
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
            >
                {openModalDuyet && <ModalTextForm show={openModalDuyet}
                    title="Đồng ý phê duyệt đơn nghỉ phép"
                    handleClose={() => setOpenModalDuyet(false)}
                    handleSave={() => { eventPheDuyet(true); setOpenModalDuyet(false); }}>
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Đồng ý </label> phê duyệt đơn thêm giờ này không? Hãy nhập nội dung (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                        </Col>
                    </Row>
                </ModalTextForm>}
                {openModalTuChoi && <ModalTextForm show={openModalTuChoi}
                    title="Từ chối phê duyệt đơn thêm giờ"
                    handleClose={() => setOpenModalTuChoi(false)}
                    handleSave={() => { eventPheDuyet(false); setOpenModalTuChoi(false); }}>
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Từ chối</label> phê duyệt đơn thêm giờ này không? Hãy nhập lý do (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                        </Col>
                    </Row>
                </ModalTextForm>}
                {openModalYKien && <ModalTextForm show={openModalYKien}
                    title="Đưa ý kiến cho đơn nghỉ phép"
                    handleClose={() => setOpenModalYKien(false)}
                    handleSave={() => { onDuaYKien(); setOpenModalYKien(false); }}>
                    <Form
                        form={formDuaYKien}
                        onFinish={() => { }}
                        validateMessages={validateMessages}
                    >
                        <Form.Item label="Ý kiến" name="duyet" rules={[{ required: true }]}>
                            <Radio.Group>
                                <Radio value={true}>Đồng ý</Radio>
                                <Radio value={false}>Từ chối</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item
                            label="Nội dung ý kiến"
                            name="noiDung"
                        >
                            <TextArea placeholder="Nội dung" />
                        </Form.Item>
                    </Form>
                </ModalTextForm>}
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Tabs
                                tabBarExtraContent={
                                    <Space>
                                        {
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                htmlType="submit"
                                                icon={<SendOutlined rev="" />}
                                                onClick={onTrinh}
                                            >
                                                Lưu & Gửi phê duyệt
                                            </Button>
                                        }
                                        {
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SaveOutlined rev="" />}
                                                htmlType="submit"
                                            >
                                                Lưu
                                            </Button>
                                        }
                                    </Space>}
                                defaultActiveKey="1" items={[
                                    {
                                        key: "1",
                                        label: <span>Thông tin</span>,
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Form.Item
                                                        name="id"
                                                        hidden
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Nhân viên"
                                                            >
                                                                {user.hoTen}
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Người ý kiến"
                                                                name="idNguoiYKien"
                                                            >
                                                                <NhanVienPhongBanSelectBox idDonVi={user.idDonVi} allowClear onChange={(e: any) => { form.setFieldValue('idNguoiYKien', e.target.value); }} idNhanVienAdd={idNguoiYKien} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Người duyệt"
                                                                name="idNguoiDuyet"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <BanGiamDocSelectBox onChange={(e: any) => { form.setFieldValue('idNguoiDuyet', e.target.value); }} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Kính gửi"
                                                                name="kinhGui"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <TextArea readOnly={isReadOnly} rows={2} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="16">
                                                            <Form.Item
                                                                label="Lý do"
                                                                name="lyDo"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <TextArea readOnly={isReadOnly} rows={2} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={24}>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Địa điểm làm việc"
                                                                name="diaDiemLamViec"
                                                            >
                                                                <Input readOnly={isReadOnly} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            {
                                                                isReadOnly ?
                                                                    <Form.Item
                                                                        label="Ngày làm thêm giờ"
                                                                        rules={[{ required: true }]}
                                                                    >
                                                                        <Input readOnly value={dateCommon.formatDate(donNgoaiGio?.ngay, "dd/MM/yyyy")} />
                                                                    </Form.Item> :
                                                                    <Form.Item
                                                                        label="Ngày làm thêm giờ"
                                                                        name="ngay"
                                                                        rules={[{ required: true }]}
                                                                    >
                                                                        <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày làm thêm giờ" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                                                    </Form.Item>

                                                            }
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Số giờ đăng ký"
                                                                name="soGio"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <InputNumber readOnly={isReadOnly} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                    }
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </Form>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
        </section>
    );
};

export default DangKyThemGio;
